import {useState} from "react";
import {Button} from './Button';
import {Link} from "react-router-dom";
import {useNavigate} from "react-router-dom";
import {Menu, X} from "lucide-react";
import {useDispatch, useSelector} from "react-redux";
import {logout} from "./slices/authSlices";

export default function Header() {
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const dispatch = useDispatch();

    const handleLogin = () => {
        setMenuOpen(false)
        navigate("/login");
    };

    const handleLogout = () => {
        dispatch(logout());
        setMenuOpen(false);
        navigate("/");
    };

    return (
        <header className="flex flex-col bg-primary text-white relative p-0">
            <div className="flex items-center justify-between p-2 gap-2">
                <div className="text-xl font-bold">Dashboard</div>

                <div className="flex items-center gap-4">

                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => setMenuOpen(true)}
                        aria-label="Open Menu"
                    >
                        <Menu/>
                    </Button>
                </div>
            </div>

            <nav className="flex text-lg gap-2 px-4 pb-2 space-x-10 overflow-x-auto whitespace-nowrap scrollbar-hide">
                <Link to="/" className="hover:underline">
                    Home
                </Link>
                <Link to="/ordermanagement" className="hover:underline">
                    Orders
                </Link>
                <Link to="/messagemanagement" className="hover:underline">
                    Messages
                </Link>
                <Link to="/productmanagement" className="hover:underline">
                    Products
                </Link>
                <Link to="/add-to-cart-data" className="hover:underline">
                    Add to Cart Data
                </Link>
                <Link to="/callback-data" className="hover:underline">
                    Callback Data
                </Link>
                <Link to="/lulu-book-management" className="hover:underline">
                    Lulu Book Management
                </Link>
                <Link to="/printifyproducts" className="hover:underline">
                    Printify Products
                </Link>
                <Link to="/teelaunchproducts" className="hover:underline">
                    Tee launch Products
                </Link>
                <Link to="/prodigiproducts" className="hover:underline">
                    Prodigi Products
                </Link>
                <Link to="/categorymanagement" className="hover:underline">
                    Category Management
                </Link>
                <Link to="/holidays" className="hover:underline">
                    Holiday Management
                </Link>
                <Link to="/promotions" className="hover:underline">
                    Promotions
                </Link>
                <Link to="/bundledproductmanagment" className="hover:underline">
                    Bundled Products
                </Link>
            </nav>

            {menuOpen && (
                <div className="fixed inset-0 bg-primary-dark text-white flex flex-col z-50">
                    <div className="flex items-center justify-between p-4">
                        <div className="text-xl font-bold">Menu</div>
                        <Button
                            variant="ghost"
                            size="icon"
                            onClick={() => setMenuOpen(false)}
                            aria-label="Close Menu"
                        >
                            <X/>
                        </Button>
                    </div>

                    <div className="flex flex-col items-center gap-4 p-4 text-lg">
                        <Link
                            to="/"
                            onClick={() => setMenuOpen(false)}
                            className="hover:underline"
                        >
                            Home
                        </Link>
                        <div className="flex flex-col gap-4 items-center">
                            <Link
                                to="/ordermanagement"
                                onClick={() => setMenuOpen(false)}
                                className="hover:underline"
                            >
                                Order Management
                            </Link>
                        </div>
                        <div className="flex flex-col gap-4 items-center">
                            <Link
                                to="/messagemanagement"
                                onClick={() => setMenuOpen(false)}
                                className="hover:underline"
                            >
                                Messages
                            </Link>
                        </div>
                        <div className="flex flex-col gap-4 items-center">
                            <Link
                                to="/productmanagement"
                                onClick={() => setMenuOpen(false)}
                                className="hover:underline"
                            >
                                Product Management
                            </Link>
                        </div>
                        <div className="flex flex-col gap-4 items-center">
                            <Link
                                to="/add-to-cart-data"
                                onClick={() => setMenuOpen(false)}
                                className="hover:underline"
                            >
                                Add to Cart Data
                            </Link>
                        </div>
                        <div className="flex flex-col gap-4 items-center">
                            <Link
                                to="/callback-data"
                                onClick={() => setMenuOpen(false)}
                                className="hover:underline"
                            >
                                Callback Data
                            </Link>
                        </div>
                        <div className="flex flex-col gap-4 items-center">
                            <Link
                                to="/lulu-book-management"
                                onClick={() => setMenuOpen(false)}
                                className="hover:underline"
                            >
                                Lulu Book Management
                            </Link>
                        </div>
                        <div className="flex flex-col gap-4 items-center">
                            <Link
                                to="/printifyproducts"
                                onClick={() => setMenuOpen(false)}
                                className="hover:underline"
                            >
                                Printify Products
                            </Link>
                        </div>
                        <div className="flex flex-col gap-4 items-center">
                            <Link
                                to="/prodigiproducts"
                                onClick={() => setMenuOpen(false)}
                                className="hover:underline"
                            >
                                Prodigi Products
                            </Link>
                        </div>
                        <div className="flex flex-col gap-4 items-center">
                            <Link
                                to="/categorymanagement"
                                onClick={() => setMenuOpen(false)}
                                className="hover:underline"
                            >
                                Category Management
                            </Link>
                        </div>
                        <div className="flex flex-col gap-4 items-center">
                            <Link
                                to="/promotions"
                                onClick={() => setMenuOpen(false)}
                                className="hover:underline"
                            >
                                Promotions
                            </Link>
                        </div>
                        <div className="flex flex-col gap-4 items-center">
                            <Link
                                to="/bundledproductmanagment"
                                onClick={() => setMenuOpen(false)}
                                className="hover:underline"
                            >
                                Bundled Product Management
                            </Link>
                        </div>
                    </div>

                    <div className="p-4 border-t border-white/20 mt-auto">
                        {isLoggedIn ? (
                                <Button variant="menu" onClick={handleLogout}>Logout</Button>
                            )
                            :
                            (
                                <Button variant="menu" onClick={handleLogin}>Login</Button>
                            )
                        }
                    </div>
                </div>
            )}
        </header>
    )
        ;
}
